import React from 'react'
import { message, Checkbox } from 'antd'
import { deleteCategory } from '../../../services/api/apiBatchShip'
import CategoryRow from './CategoryRow'

const CategoryTable = ({ categorys, loading, error, reload, skus, listSelected, selectAll, handleSelectAll, handleSelectItem }) => {

    const handleDelete = async (categoryId, name) => {
        try {
            const { data } = await deleteCategory(categoryId)
            const { success, message: mess } = data
            if (!success) throw new Error(mess)
            message.success(`Xóa danh mục ${name} thành công.`)
            reload()
        } catch (e) {
            message.error(e.message)
        }
    }

    const _renderTableContent = () => {
        if (loading) {
            return <tr>
                <td colSpan={5}>Loading ...</td>
            </tr>
        }

        if (categorys.length === 0 && !error) {
            return <tr>
                <td colSpan={5}>No data</td>
            </tr>
        }

        if (!!error) {
            return <tr>
                <td colSpan={5} className='text-danger'>{error}</td>
            </tr>
        }

        return categorys.length > 0 && categorys.map((category) => (
            <CategoryRow
                key={category._id}
                category={category}
                skus={skus}
                reload={reload}
                onleDelete={handleDelete}
                listSelected={listSelected}
                handleSelectItem={handleSelectItem}
            />
        ))
    }

    return (
        <div className="CategoryTable SkuTable">
            <table className="table table-striped">
                <thead className="TableHead">
                    <tr className='CategoryTableHead px-0'>
                        <th><Checkbox checked={selectAll} onClick={(e) => handleSelectAll(e.target.checked)} /></th>
                        <th className='category'>Danh mục sản phẩm</th>
                        <th className='sku'>SKU</th>
                        <th className='created'>Ngày tạo</th>
                        <th className='updated'>Ngày cập nhật</th>
                        <th className='action'>Hành động</th>
                    </tr>
                </thead>
                <tbody className="TableBody">
                    {_renderTableContent()}
                </tbody>
            </table>
        </div>
    )
}

export default CategoryTable